module.exports = __webpack_public_path__ + "img/2AA.1.9649bf40.jpg";